import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { TokenStorageService } from '../auth/services/token-storage.service';
import { LoginService } from '../services/login.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const tokenStorageService = inject(TokenStorageService);
    const loginService = inject(LoginService);
    const excludedUrls = ['/open/login', '/open/refresh', '/open/reset', '/open/update-password', '/open/reset/password'];
    const shouldExclude = excludedUrls.some((url) => req.url.includes(url)) || req.headers.has('skip');

    if (shouldExclude) {
      return next.handle(req);
    }

    const token = tokenStorageService.getToken();

    if (token) {
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (tokenStorageService.isTokenValid()) {
        return next.handle(authReq);
      } else {
        return next.handle(authReq).pipe(
          catchError((error: HttpErrorResponse) => {
            if (
              (error.error.customMessage === "INVALID_TOKEN" &&
                !req.url.includes('/open/refresh'))
            ) {
              return loginService.refreshToken().pipe(
                switchMap((token) => {
                  const newAuthReq = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${token.token}`,
                    },
                  });
                  return next.handle(newAuthReq);
                }),
                catchError((refreshError) => {
                  return throwError(() => {
                    loginService.logout();
                    return refreshError;
                  });
                })
              );
            }
            return throwError(() => error);
          })
        );
      }
    }
    return next.handle(req);
  }
}
